import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { status } = useAuth();
  const { t } = useLang();

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-sm text-muted-foreground animate-pulse font-mono">
          {t("checking")}
        </div>
      </div>
    );
  }
  if (status === "anon") return <Navigate to="/login" replace />;
  return children;
}
